import React from "react";
import { CheckIcon } from "../../assets";
import styles from "./styles.module.scss";

export default function ActiveButton() {
  return (
    <div className={styles.activeButton}>{<CheckIcon color="white" />}</div>
  );
}
